<template>
  <tr class="cabinet__tbody-row">
    <td style="width: 10%">
      {{ item.id }}
    </td>
    <td style="width: 54%">
      {{ item.title }}
    </td>
    <td style="width: 12%">
      {{ item.quantity }}
    </td>
    <td style="width: 8%">
      {{ item.unitName }}
    </td>
    <!--    <td style="width: 12%">{{ item.price }}</td>-->
    <!--    <td style="width: 12%">{{ item.sum }}</td>-->
    <td style="width: 12%">
      {{ item.deliveryDate }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--tooltip">
      <div class="cabinet__tbody-btns">
        <button
          class="cabinet__tbody-btn cabinet__tbody-btn--paper-plus"
          type="button"
          :style="{display: !item.showed ? 'block' : 'none'}"
          @click="showOffer"
        />
        <button
          class="cabinet__tbody-btn cabinet__tbody-btn--exit"
          type="button"
          :style="{display: item.showed ? 'block' : 'none'}"
          @click="hideOffer"
        />
      </div>
    </td>
  </tr>
  <tr class="cabinet__block">
    <td
      class="cabinet__block-td"
      colspan="6"
    >
      <div
        class="cabinet__block-form"
        :style="{display: item.showed ? 'block' : 'none'}"
      >
        <h4 class="cabinet__block-title">
          Подтверждение поставки
        </h4>
        <div
          v-if="!disabled || !item.task.supplierCancel"
          class="row"
        >
          <div class="col-12 ps-5">
            <div class="row">
              <div class="col-4">
                <div class="cabinet__block-inputBox">
                  <p class="cabinet__block-inputBox-title">
                    Количество
                  </p>
                  <InputForm
                    v-model:value="item.task.supplierQuantity"
                    input-class="purchases__form-input text-right purchases__form-input--green-text"
                    type="number"
                    :max-number-value="item.quantity"
                    :disabled="disabled"
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="cabinet__block-inputBox">
                  <p class="cabinet__block-inputBox-title">
                    Ед.изм.
                  </p>
                  <p class="cabinet__block-inputBox-title">
                    {{ item.unitName }}
                  </p>
                </div>
              </div>
              <div class="col-6">
                <div class="cabinet__block-inputBox">
                  <p class="cabinet__block-inputBox-title">
                    Дата поставки Поставщика
                  </p>
                  <InputForm
                    v-model:value="item.task.supplierDeliveryDate"
                    :disabled="disabled"
                    class="auth__input-block"
                    form-key="form.publicationDate"
                    type="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!disabled"
          class="ps-5 mt-2"
        >
          или
        </div>

        <div
          v-if="!disabled || item.task.supplierCancel"
          class="row mt-4"
        >
          <div class="col-12 ps-5 d-flex">
            <div class="row">
              <div class="col-5">
                <label class="purchases__checkbox-wrapper purchases__checkbox-wrapper--request">
                  <input
                    v-model="item.task.supplierCancel"
                    :disabled="disabled"
                    class="purchases__checkbox-input"
                    type="checkbox"
                    name="check"
                  >
                  <span class="purchases__checkbox-span" />
                  <span class="purchases__checkbox-title">
                    Отмена Поставщика
                  </span>
                  <span class="purchases__checkbox-subtitle">
                    Устанавливается поставщиком или проверяющим в случае, если поставщик не может поставить позицию номенклатуры или проверяющего не устраивает дата поставки от поставщика
                  </span>
                </label>
              </div>
              <div
                v-if="item.task.supplierCancel"
                class="col-5 offset-2"
              >
                <div class="cabinet__block-inputBox">
                  <p class="cabinet__block-inputBox-title mt-0">
                    Наименование материала
                  </p>
                  <input
                    v-model="item.task.supplierCancelReason"
                    :disabled="disabled"
                    class="purchases__form-input purchases__form-input--green-text"
                    type="text"
                  >
                  <p class="cabinet__block-inputBox-desc">
                    поле является обязательным
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { dateFormat } from '@/utils/helpers';
import InputForm from '@/components/form/input-form';
import { mapGetters } from 'vuex';

export default {
  name: 'SupplyTaskDetailsTable',
  components: {
    InputForm,
  },
  props: {
    item: {
      type: Object,
    },
  },
  mounted() {
    console.log(this.item);
  },
  computed: {
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),
    disabled() {
      return this.hasRole('customer');
    },
    id() {
      return this.item.id;
    },
    idFormatted() {
      return this.item.id.toString()
        .padStart(10, '0');
    },
    status() {
      return this.item.status;
    },
    documentDate() {
      return dateFormat(this.item.documentDate);
    },
    objectName() {
      return this.item.objectName;
    },
    organizationName() {
      return this.item.organizationName;
    },
  },
  methods: {
    showOffer() {
      this.item.showed = true;
    },
    hideOffer() {
      this.item.showed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.show-contract {
  display: block;
  width: 20px;
  height: 20px;
  color: transparent;
  content: '';
  margin: 0 5px;
}
</style>
